//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    cols: {
      type: Number,
      default: null
    },
    spacing: {
      type: String,
      default: null
    }
  }
}
